import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const EmptyPlaceholder = styled.div`
  display: flex;
  justify-content: center;
  font-size: 16px;
  align-items: center;
  color: ${colors.purple300};
`
